// A meal-plan slot holds one of three kinds of thing (see entry_type on the
// backend). This resolves a raw entry against the currently-loaded
// recipes/ingredients/events lists to the { kind, item } the calendar
// actually renders -- shared between the desktop and mobile views so they
// don't each reimplement (and drift on) the same lookup.
export function resolveMealPlanEntryItem(entry, { recipes, ingredients, events }) {
  if (entry.entry_type === 'ingredient') {
    const item = ingredients.find((i) => String(i.id) === String(entry.ingredient?.ingredient_id));
    return item ? { kind: 'ingredient', item } : null;
  }

  if (entry.entry_type === 'event') {
    const item = events.find((e) => String(e.id) === String(entry.event_id));
    return item ? { kind: 'event', item } : null;
  }

  const item = recipes.find((r) => r.id === entry.recipe_id);
  return item ? { kind: 'recipe', item } : null;
}
